import   React,
       { useEffect,
         useState,
         useContext } from 'react';
import { withRouter,
         Redirect } from 'react-router-dom';
import { Button,
         Link,
         Fade,
         Container } from '@material-ui/core';
import { makeStyles,
         withStyles } from '@material-ui/core/styles';
import { GATag, 
         setOffsetWidth, 
         sleep,
         Stack } from "../util/tools";
import { INFO,
         TIMES,
         RUNS,
         clearRUNS,
         CONSTS } from "../util/object";
import { getPersonalTarget, NOW } from "../util/util";
import { processPerRepStars } from '../util/performance';
import { displayText } from "../util/annotate";
import { appContext } from "./index";
import { VIMEO_POST } from "../util/constants";
import   Tutorial  from "./Tutorial";
import { UTIL_useStyles,
         GameTarget,
         Notice,
         Direction,
        } from "./Util";  
import { LocalConvenienceStoreOutlined } from '@material-ui/icons';
import { AuthClass } from '../class/AuthClass';
import { TargetClass } from '../class/TargetClass';
import { getOrMakeEngine } from '@tensorflow/tfjs-core/dist/engine';
//import { setSyntheticTrailingComments } from 'typescript';
var auth = new AuthClass();

const game_useStyles = makeStyles(theme => ({
    game_root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'row',       //'column',
        justifySelf: "flex-start",
        padding: '0',
        margin: '0',
        paddingTop: CONSTS.GOBACK_BAR_HEIGHT+"px",
        height: 'auto',     // was auto
        width: 'auto',      //'100%',
        zIndex: '0',
        backgroundColor: '#ffffff',     //'rgba(200,0,0,0.2)',     // transparent

        //maxHeight: '100%',
        //maxWidth: '100%',
        //paddingTop: '50px',
        //backgroundColor: '#a0a5b8',
    },
    replay_game_root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        height: 'auto',     // was auto
        width: '100%',
        padding: "0",
        backgroundColor: 'rgba(200,0,0,0.2)',     // transparent
        marginTop: '10px',
        zIndex: '0',
    },
    game_canvas: {      // for touch input
        position: 'absolute',
        top: '0',
        left: '0',
        display: 'block',
        height: '100%',
        width: '100%',
        margin: '0',
        padding: '0',
        textAlign: 'center',
        background: 'rgba(0,200,0,0.2)',        // #9eac9e
        zIndex: '380',        // in front of the targets
    },
    game_output: {      // for recording
        position: 'absolute',
        top: '0',
        left: '0',
        height: '100%',
        width: '100%',
        margin: '0',
        padding: '0',
        textAlign: 'center',
        background: '#cccf1d66',        // #9eac9e
        zIndex: '0',        // in front of the targets
    },
    no_game_canvas: {
        display: 'none',
    },
    stars_container: {
        display: 'flex',
        flexDirection: 'row',
        position: "absolute", 
        top: "50px", 
        right: "10px", 
        width: "120px", 
        height: "40px",
        //background: "red",
    },
    star_icon: {
        width: '30px',
        height: '30px',
        padding: '0',
        margin: '0',
    }
}));


// Display top level menu
const Game = (props) => {
    const classes = game_useStyles();
    const Classes = UTIL_useStyles();
    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }
    const [ Target, setTarget ] = useState(null);
    const [ TargetSize, setTargetSize ] = useState(null);
    const [ TargetRedirect, setTargetRedirect ] = useState("");
    const [ Show, setShow ] = useState(null);
    const [ ShowTutorial, setShowTutorial ] = useState(false);
    const [ Refresh, setRefresh ] = useState(0);
    const [ ShowWarning, setShowWarning ] = useState(false);
    const [ ShowSteps, setShowSteps ] = useState(true);
    const [ WarningText, setWarningText ] = useState([]);
    const [ Instrns, setInstrns ] = useState([]);
    const [ DisplayScale, setDisplayScale ] = useState(1);
    const [ Replay, setReplay ] = useState(false);
    const [ ShowPreFlight, setShowPreFlight ] = useState(false);
    const [ StarCnt, setStarCnt ] = useState(0);
    const [ Width, setWidth ] = useState(null);

    useEffect(() => {
        //var canvas = document.getElementById('game_canvas');
        var canvas = document.querySelector('#drill_output');
        INFO.override.disable_catalog_swipe = true;      // to avoid conflict

        console.log("Game.92:   GAME INIT START   replay=",props.Replay);
        setTargetSize(60);

        window.addEventListener('resize', adjustGameDisplay);
        window.addEventListener("orientationchange", adjustGameDisplay);

        var canvas = document.querySelector('#drill_output');
        canvas.addEventListener('touchstart', handleTouchStart, false);
        canvas.addEventListener('touchend', handleTouchEnd, false);
        //canvas.addEventListener('mousedown', handleTouchStart, false);
        //canvas.addEventListener('mouseup', handleTouchEnd, false);
        return function cleanup() {
            var canvas = document.querySelector('#drill_output');
            console.log("Game.90:   CLEANUP GAME Mode.....", Refresh);
            INFO.override.disable_catalog_swipe = false;
            setShowWarning(false);
            window.removeEventListener('resize', adjustGameDisplay);
            window.removeEventListener("orientationchange", adjustGameDisplay);
            canvas.removeEventListener('touchstart', handleTouchStart, false);
            canvas.removeEventListener('touchend', handleTouchEnd, false);
            //canvas.removeEventListener('mousedown', handleTouchStart, false);
            //canvas.removeEventListener('mouseup', handleTouchEnd, false);
            cleanUp();      // remove all targets
        }
    }, [1]);


    useEffect(() => {
        //console.log("game.62:   ..... Game Refresh");
    }, [Refresh, Target, StarCnt, TargetSize]);


    useEffect(() => {

        if(props.Replay === true) {
            var warnings = [], warning = {};
            warning.title = "ERROR: ";
            warning.value = "NONE!";
            warnings.push(warning);
            setShowWarning(false);
            setWarningText(warnings);

            var outputs = [];
            var out1 = {};
            out1.title = "0 SETS:";
            out1.value = "0 REPS EACH";
            outputs.push(out1)
            setInstrns(outputs);
            setTargetSize(15);

            setShowSteps(false);
            setShowWarning(false);
            setShowTutorial(false);

            var scale = 0.5;
            setDisplayScale(scale)
            setReplay(true)
            console.log("Game.95:   INIT START GAME REPLAY MODE.... scale=",scale);
        } else {
            setTargetSize(60);
        }

    }, [props.Replay]);

    useEffect(() => {
        // start replay only after we have the motion data
        //
        if ((props.Scheme !== null) && (props.Scheme !== undefined) && (props.Scheme.length > 0 )) {
            if(props.Replay === true) {
                console.log("Game.147:   START GAME REPLAY MODE....");
                setShowSteps(false);
                setShowWarning(false);
                setShowTutorial(false);
                setInstrns(props.Instrns);

                setupGame();
                startGame();
            }
            setRefresh(Date.now());
        }
    }, [props.Scheme]);


    useEffect(() => {
        adjustGameDisplay();
        if (props.GameStarted == true) {
            setShowSteps(false);
            setupGame();
            startGame();
            setWidth("100%")
        } else {
            setWidth("calc(100% - "+INFO.sidebar_width+")");
            setShowSteps(true);
            cleanUp();
            INFO.game_running = false;
        }

        setRefresh(Date.now());
    }, [props.GameStarted]);
    //}, [props.GameCnt]);



    function cleanUp() {
        //console.log("game.171:      ENTER TARGET CLEAN UP...  ", INFO.game_target.length);
        for(var i = 0; i < INFO.game_target.length; i++ ) {
            //console.log("game.173:      CLEAN UP TARGET.",i,"...  ", INFO.game_target[i]);
            INFO.game_target[i].stop();   // remove previous target objects;
            INFO.game_target[i].destroy();   // remove previous target objects;
        }
    }


    function simulateClick(x, y) {
        console.log("game.193:  **********  SIMULATE CLICK:  x=",x, " y=",y);
        var i = 0;
        if(INFO.game_target[i] !== undefined) {
            console.log("game.307:  HIDE Target  x=", INFO.game_target[i].x, " y=",INFO.game_target[i].y);
            INFO.game_target[i].stop();   // remove previous target objects;
            INFO.game_target[i].destroy();   // remove previous target objects;
        }

        //if(INFO.game_rounds < CONSTS.GAME_MAX_CNT) {
        if(INFO.game_rounds < INFO.max_reps) {
            console.log("game.203:    SIMULATE NEXT:  ",INFO.game_rounds);
            startNextTarget("simu.243");
        } else {
            console.log("game.206:    SIMULATE ENDED:  ",INFO.game_rounds);
        }
    }


    async function newTarget(init) {
        var wait_msec = Math.floor((Math.random() * CONSTS.GAME_MAX_WAIT_MSEC) + CONSTS.GAME_MIN_WAIT_MSEC);

        function _activate_target(from, init) {
            if(INFO.game_running == false) {
                console.log("game.199:            GAME STOPPED, CAN NOT ACTIVATE NEW TARGET");
                return null;
            }

            var scheme = INFO.game_schemes[INFO.game_scheme_idx];
            INFO.game_scheme = scheme;
            var target_element = document.getElementById('target0');
            var target = new TargetClass(target_element);
            //var color = (init == true) ? "green" : "red";
            //target.color = color;

            //var status = target.create(scheme, INFO.game_screen, DisplayScale);
            var scale = (INFO.drill_param1.scale) ? INFO.drill_param1.scale : 1;    // for timer mode: in "real time sec" before kick
            var status = target.create(scheme, INFO.game_screen, scale);
            var ball = (INFO.drill_param1.ball) ? parseInt(INFO.drill_param1.ball) : 60;    // for timer mode: in "real time sec" before kick
            setTargetSize(ball);
            //console.log("game.271:          B4 ACTIVATE TARGET...  from",from, " scheme=",scheme, "  game_screen=", INFO.game_screen, " scale=",scale);

            if(status == null) {
                endGame("error");       // target create went wrong
                return;
            }
            console.log("game.184:          ACTIVATE TARGET...  from",from, "  scheme=",scheme.type, "  idx=",INFO.game_scheme_idx, " color=",target.color," init=",init," scale=",scale);
            var animated = target.start();
            INFO.game_scheme_idx = ((INFO.game_scheme_idx + 1) % INFO.game_schemes.length);     // loop
            console.log("game.279:                 - - TARGET QUEUE:    idx=",INFO.game_scheme_idx);

            // save it for the next
            if(INFO.game_scheme.type == "lead") {
                var scheme = INFO.game_schemes[INFO.game_scheme_idx];
                scheme.x = target.last_x;
                scheme.y = target.last_y;
            }

            // setup click simulation
            //
            if (false && (Replay === true)) {
                //clicks[0] ={ delay: 210, x: 100, y: 100};
                var delay = props.GameClicks[0].delay;
                var x = props.GameClicks[0].x;
                var y = props.GameClicks[0].y;
                setTimeout(simulateClick(x, y), delay)
            }

            return [ target, animated ];
        }

        if ((props.Fingers === null) || (props.Fingers === undefined)) {
                endGame("error");       // target create went wrong
                return;
        }


        // determine new target positions
        //
        INFO.game_press_cnt = 0;    // all fingers are down, so reset for new round
        //for(var i = 0; i < props.Fingers; i++) {
        for(var i = 0; i < INFO.game_fingers; i++) {
            TIMES.game_reacted[i] = 0;
            TIMES.game_end_target[i] = 0;
        }

        if (init == true) {
            // first time only
            //for(var i = 0; i < props.Fingers; i++) {
            for(var i = 0; i < INFO.game_fingers; i++) {
                TIMES.game_show_target[i] = 0;     // the starting gun, do not time before this one

                var [ new_target, new_animate ] = _activate_target("init.320", true);
                INFO.game_target.push(new_target);
                INFO.game_animate.push(new_animate);
                //console.log('246: init animation =', new_animate);   // in case of a non-reaction on a fast moving target 
                new_animate.onfinish = () => {
                    console.log('327:          INIT TARGET ENDED WITHOUT ATTEMPT!');   // in case of a non-reaction on a fast moving target 
                    startNextTarget("init.326");
                };

                console.log("game.111: Show FIRST Target...  x=",INFO.game_target[i].x, " y=",INFO.game_target[i].y, "   cnt=",INFO.game_rounds);
            }
        } else {
            // hide the spent target
            //for(var i = 0; i < props.Fingers; i++) {
            for(var i = 0; i < INFO.game_fingers; i++) {
                if(INFO.game_target[i] !== undefined) {
                    console.log("game.304:  HIDE Target  x=", INFO.game_target[i].x, " y=",INFO.game_target[i].y);
                    INFO.game_target[i].stop();   // remove previous target objects;
                    INFO.game_target[i].destroy();   // remove previous target objects;
                }
            }
            //console.log("game.320:          CLEAR Target...   round=",INFO.game_rounds, "  target.len=",INFO.game_target.length, "  wait=",wait_msec," msec");

            /* DEBUG ONLY - ADD DELAY BEFORE STARTING NEW  - not useful
            var scheme1 = INFO.game_schemes[INFO.game_scheme_idx];
            if(scheme1.type === "base") {
                wait_msec = 2000;
            }
            */

            sleep(wait_msec)
            .then(() =>{
                // display new targets at once to force brain to parallel procss
                INFO.game_target = [];
                if ((INFO.game_running == true) && (props.Fingers !== null) && (props.Fingers !== undefined)) {
                    //for(var i = 0; i < props.Fingers; i++) {
                    for(var i = 0; i < INFO.game_fingers; i++) {
                        var [ new_target, new_animate ] = _activate_target("delay_start.354");
                        if (new_target) {
                            if(true) {
                                TIMES.game_show_target[i] = performance.now()
                                INFO.game_target.push(new_target);
                                INFO.game_animate.push(new_animate);
                            }

                            console.log('game.369:     START SECOND LEG  animate=',new_animate, " idx=",INFO.game_scheme_idx);   // in case of a non-reaction on a fast moving target 
                            if (new_target.lead === true) {
                                // set up continuation leg
                                //
                                new_animate.onfinish = () => {
                                    console.log("game.289:     .... TARGET ENDED WITHOUT ATTEMPT! ");
                                        //startNextTarget("unfinish.364");        // continue the bounce flow

                                        var [ new_target, new_animate ] = _activate_target("continue.368");
                                        INFO.game_target.push(new_target);
                                        INFO.game_animate.push(new_animate);
                                        //console.log('246: init animation =', new_animate);   // in case of a non-reaction on a fast moving target 
                                        new_animate.onfinish = () => {
                                            console.log('game.373:          SECOND LEG ENDED WITHOUT ATTEMPT!');   // in case of a non-reaction on a fast moving target 
                                            //startNextTarget("init.326");
                                        };
                                        //console.log("game.376: Showed SECOND leg...  x=",INFO.game_target[i].x, " y=",INFO.game_target[i].y, "   cnt=",INFO.game_rounds);
                                        console.log("game.376: Showed SECOND leg...  x=",new_target.x, " y=",new_target.y, "   cnt=",INFO.game_rounds);
                                };
                                //console.log("game.181: Show NEW Target...  x=",INFO.game_target[i].x, " y=",INFO.game_target[i].y, "   round=",INFO.game_rounds, "  target.len=",INFO.game_target.length);
                            }
                        }
                    }
                }
            })
        }

    }


    // setup the game before starting
    //
    function setupGame() {
        var display = document.querySelector('#drill_video_container');
        var canvas = document.querySelector('#drill_output');
        var ctx = canvas.getContext("2d");
        var ww = display.offsetWidth;
        var hh = display.offsetHeight;

        ctx.clearRect(0, 0, ww, hh);    // clear canvas
        ctx.fill();

        INFO.game_schemes = [...props.Scheme];
        INFO.game_scheme_idx = 0;
        INFO.game_screen = {x: ww, y: hh};


        // Note: game will start when everything is loaded
        console.log("game.309:  GAME LOAD schemes=",INFO.game_schemes, " param1=",INFO.drill_param1);
    }


    // main entry for game session
    //
    function startGame() {
        //var canvas = document.getElementById('game_canvas');
        var canvas = document.querySelector('#drill_output');
		var ctx = canvas.getContext("2d");

        TIMES.game_perf_react = [];
        TIMES.game_perf_good = [];
        TIMES.game_perf_bad = [];
        TIMES.timer_stop_display = 0;   // for displaying warning msgs
        TIMES.session_start = Date.now();   // each finger run is a session
        INFO.notify_messages = [];      // KLUDGE: This should be init earlier

        INFO.game_press_valid = false;
        INFO.game_press_cnt = 0;
        INFO.game_rounds = 0;
        INFO.game_running = true;
        INFO.game_target = []
        INFO.game_animate = []
        INFO.out_context = ctx;       // prime_context?

        //var scale = (INFO.drill_param1.scale) ? INFO.drill_param1.scale : 1;    // for timer mode: in "real time sec" before kick
        //setDisplayScale(scale)

        var warnings = getPersonalTarget();
        if (warnings !== null) {
            setShowPreFlight(true);
            setWarningText(warnings);
            setTimeout(()=>{ setShowPreFlight(false) }, 3000)
        }

        // <Notice> TESTING SCAFOLD
        if(false) {
                var warning = {}, warnings = [];
                warning.title = "ERROR: ";
                warning.value = "KEEP FINGER ON DOT!";
                warnings.push(warning);
                setShowWarning(true);
                setWarningText(warnings);
        }

        clearRUNS();
        cleanUp();
        newTarget(true);
        console.log("game.200: GAME STARTED...  param1=",INFO.drill_param1, "  schemes=",INFO.game_schemes);
    }

    // main entry to check if game has ended;
    //
    function endGame(mode) {
        //console.log("game.308: STOPPING GAME?  round=",INFO.game_rounds, "  mode=",mode, "  target=", INFO.game_target.length);
        cleanUp();
        switch (mode) {
            case "interrupt":
                INFO.game_running = false;
                props.Finished(mode);
                return true;
            case "error":
                INFO.game_running = false;
                props.Finished(mode);
                return true;
            default:
                //if(INFO.game_rounds > CONSTS.GAME_MAX_CNT) {
                if(INFO.game_rounds >= INFO.max_reps) {
                    //setGameOn(false);
                    INFO.game_running = false;
                    props.Finished(mode);
                    return true;
                } else {
                    return false;
                }
                break;
        }
    }

    const handleDismissTutorial = () => {
        console.log("menu.92: ----->  REACHED HANDLE_DISMISS_TUTORIAL");
        setShowTutorial(false);
    }


    const adjustGameDisplay = () => {
        //var display = document.getElementById('game_root');
        //var canvas = document.getElementById('game_canvas');
        var display = document.querySelector('#drill_video_container');
        var canvas = document.querySelector('#drill_output');
        var ww = display.offsetWidth;
        var hh = display.offsetHeight;

        canvas.width = ww;      // VERY IMPORTANT TO SET CANVAS SIZE!!!
        canvas.height = hh;
        //console.log("game_display.333:  GAME CANVAS  wd=",canvas.width, " ht=",canvas.height);
    }


    // ref: https://developer.mozilla.org/en-US/docs/Web/API/Touch_events
    // code: https://jsfiddle.net/Darbicus/z3Xdx/10/
    const handleTouchStart = event => {
        event.preventDefault();     // block new ones to prevent overflow
        var touches = event.targetTouches;
        var has_hit = false, target = -1, done_cnt;

        if ((INFO.game_running == false) || (Replay === true)) {
            return;
        }

        //console.log("touch.97:  event.targetTouches=", event.targetTouches);
        done_cnt = 0;
        var touch_cnt = (event.targetTouches === undefined) ? 1 : event.targetTouches.length;

        // detect if using two hands in a one hand drill
        console.error("game.541:      ! ! ! ! !  TOO MANY HANDS   Fingers=",props.Fingers, " game_fingers=",INFO.game_fingers,"  touch_cnt=",touch_cnt);
        //if (touch_cnt > props.Fingers) {
        if (touch_cnt > INFO.game_fingers) {
            var warnings = [], warning = {};
            warning.title = "ERROR: ";
            warning.value = "ONLY ONE HAND ALLOWED!";
            warnings.push(warning);
            setShowWarning(true);
            setWarningText(warnings);
            setTimeout(() => {
                // display warning and then invalidate the target(s)
                setShowWarning(false);
                //INFO.game_rounds = CONSTS.GAME_MAX_CNT;     // abort game
                //INFO.game_press_cnt = props.Fingers;        // for exit
                //for(var i = 0; i < props.Fingers; i++) {
                for(var i = 0; i < INFO.game_fingers; i++) {
                    if(INFO.game_target[i] !== undefined) {
                        INFO.game_target[i].color = 'rgba(180,180,180,0.9)';
                        console.log("game.344:    !!!!! TERMINATE Target  x=", INFO.game_target[i].x, " y=",INFO.game_target[i].y);
                    } else {
                        console.log("game.446:          BAD CANCEL TARGET!    target=", INFO.game_target);
                    }

                    TIMES.game_end_target[i] = 666;     // special cancel code
                }
                console.log("game.362:         INTERRUPTING CURRENT GAME!");
                endGame("interrupt");
            }, 2500);
        }

        if (touch_cnt > 0) {
            // check each touch to see if it hits a target
            for(var i = 0; i < touch_cnt; i++) {
                var touch = touches[i];
                var x = Math.floor(touch.clientX);
                var y = Math.floor(touch.clientY - 50);     // MEGA-KLUDGE:  Adjust for the Top bar offset?  CLEAN UP LATER!
                var xx = Math.floor(touch.radiusX) + 2;
                var yy = Math.floor(touch.radiusY) + 2;

                // loop against every goal, either find a hit one or total miss
                INFO.game_press_cnt = INFO.game_press_cnt + 1;  // no matter what -> ?? where is this reset?
                has_hit = false;
                target = 0;
                //for(var j = 0; j < props.Fingers; j++) {
                for(var j = 0; j < INFO.game_fingers; j++) {
                    if ((TIMES.game_show_target[j] > 0) && (INFO.game_target[j] !== undefined)) {

                        has_hit = INFO.game_target[j].hit(x, y, xx, yy);
                        if(has_hit == true) {
                            target = j;
                        }
                    }
                }

                if (INFO.game_press_valid == false) {
                    has_hit = false;        // override - early lift penalty
                }

                if (INFO.game_scheme.type !== "lead") {

                    // process star count to give user feedback
                    //      - store in RUNS, set the stars
                    var run = {};
                    run.game_reacted = TIMES.game_reacted[target];
                    run.game_show_target = TIMES.game_show_target[target];
                    run.end_run = t0;
                    run.hit = has_hit;
                    RUNS.push(run);     // result collected in displayRunResults();

                    var t0 = performance.now();
                    var time = Math.floor(t0 - TIMES.game_show_target[target]);
                    if(has_hit == true) {
                        TIMES.game_end_target[target] = t0;
                        TIMES.game_perf_good.push(time);

                        processPerRepStars(run, "game");    // calc drill_stars
                        setStarCnt(INFO.drill_stars);
                        //console.log("touch.214:  ******** HIT TARGET!   TIME=",time, " x=",x, " y=",y);
                    } else {
                        TIMES.game_perf_bad.push(time);
                        setStarCnt(0);      // do not display stars if it's a miss!
                        //console.log("touch.433:  ******** MISS TARGET!   TIME=",time, " x=",x, " y=",y);
                    }
                }
            }

            // detect end of round, "early lift" will terminate a round
            done_cnt = 0;
            //for(var j = 0; j < props.Fingers; j++) {
            for(var j = 0; j < INFO.game_fingers; j++) {
                if(TIMES.game_end_target[j] > 0) {
                    done_cnt = done_cnt + 1;
                };
            }


            // wait untill all fingers are down before display new target
            //
            //if ((INFO.game_rounds < INFO.max_reps) && ((INFO.game_rounds == 0) || (INFO.game_press_cnt == props.Fingers))) {
            if ((INFO.game_rounds < INFO.max_reps) && ((INFO.game_rounds == 0) || (INFO.game_press_cnt == INFO.game_fingers))) {
                startNextTarget("all_finger.602");
            }
        }
    }

    // launch next target
    const startNextTarget = (from) => {
        //if ((INFO.game_rounds > CONSTS.GAME_MAX_CNT) || (Replay === true)) {
        if ((INFO.game_rounds > INFO.max_reps) || (Replay === true)) {
            return;
        }
        console.log("start.645: ********* START NEXT TARGET  from=",from," type=",INFO.game_scheme.type, "  round=", INFO.game_rounds, " next_idx=",INFO.game_scheme_idx);

        if (INFO.game_scheme.type == "lead") {
            // last leg does not count in stats
            INFO.game_target = [];      // clear old stuff
            INFO.game_animate = [];      // clear old stuff
            newTarget(false);
        }

        // start next timed round
        //
        INFO.game_rounds = INFO.game_rounds + 1;
        if (endGame("save") == false) {
            INFO.game_target = [];      // clear old stuff
            INFO.game_animate = [];      // clear old stuff
            newTarget(false);
        }
    }


    // a finger has been lifted up, either calc reaction time or too early
    //
    const handleTouchEnd = event => {
        event.preventDefault();     // block new ones to prevent overflow
        var touches = event.changedTouches;
        var react_time;

        if ((INFO.game_running == false) || (Replay === true)) {
            return;
        }

        var t0 = performance.now();
        //console.log("game.346:  Finger LIFTED  cnt=", touches.length, "  targets=",INFO.game_target.length);

        //if (INFO.game_target_x[0] == 0) {
        if (INFO.game_target.length == 0) {
            // if not already displaying something
            if(ShowWarning == false) {
                // no target shown yet, so finger lifted TOO EARLY!
                var warnings = [], warning = {};
                warning.title = "ERROR: ";
                warning.value = "KEEP FINGER ON DOT!";
                warnings.push(warning);
                setShowWarning(true);
                setWarningText(warnings);
                setTimeout(() => {
                    // display warning and then invalidate the target(s)
                    setShowWarning(false);
                    //for(var i = 0; i < props.Fingers; i++) {
                    for(var i = 0; i < INFO.game_fingers; i++) {
                        //showCircle(INFO.game_target[i].x, INFO.game_target[i].y, CONSTS.GAME_TARGET_SIZE, 'rgba(255,255,255,0.9)');
                        if ((INFO.game_target[i] !== undefined) && (INFO.game_target[i] !== null)) {
                            INFO.game_target[i].color = 'rgba(180,180,180,0.9)';
                            TIMES.game_end_target[i] = 666;     // special cancel code
                            console.log("game.307:       !!!! LIFTED, CANCEL Target  x=", INFO.game_target[i].x, " y=",INFO.game_target[i].y);
                        } else {
                            //console.log("game.422:  BAD CANCEL TARGET!    target=", INFO.game_target);
                        }
                    }
                }, 800);
            }
        } else {
            // a finger lifted, use FIFO it since we don't know which
            INFO.game_press_valid = true;
            for(var j = 0; j < touches.length; j++) {
                var target = -1;
                //for(var i = 0; i < props.Fingers; i++) {
                for(var i = 0; i < INFO.game_fingers; i++) {
                    if (TIMES.game_reacted[i] == 0) {     // measure R4 reaction time
                        target = i;
                        break;
                    }
                }
                ///console.log("game.376:  .....target=", target);
                if(target >= 0) {
                    TIMES.game_reacted[target] = t0;     // measure R4 reaction time
                    react_time = Math.floor(TIMES.game_reacted[target] - TIMES.game_show_target[target]);
                    TIMES.game_perf_react.push(react_time);

                    console.log("game.314:       @@ REACTED To Target    ******  react_time=", react_time, " msec  ******  stars=",INFO.drill_stars);
                    //console.log("game.314:  REACTED To Target  x=", INFO.game_target[target].x, " y=",INFO.game_target[target].y);
                }
            }
        }
    }


    const Stars = (props) => {
        const [ STARS, setSTARS ] = useState([]);
        useEffect(() => {
            var stars = []
            for (var i = 0; i < props.StarCnt; i++) {
                stars.push(i);        // XXCD: KLUDGE: STUPID WAY TO DO THIS....NEED TO FIX
            }
            //console.log('getSTAR.670:  -------> DRAW STARS    XXXXXXXX stars=',props.StarCnt, " stars=",stars);
            setSTARS(stars);
        }, [props.StarCnt]);

        useEffect(() => {
        }, [STARS]);

        return (
            <React.Fragment>
                {STARS.map(
                    (item, indx) => {
                        return( <img key={"img"+indx} src={require("../assets/images/star75.png")} className={classes.star_icon} /> )
                    }
                )}
            </React.Fragment>
        )
    }



    const renderRedirect = () => {
        if (TargetRedirect !== "") {
            GATag("menu", Target, "jump");  // (cat, act, lab, val)
            console.log("#################### menu.renderRedirect:   Showing ", Target);
            return <Redirect to={Target} />
        }
        return ""
    }

    /*
                    <Container id="game_root" className={classes.game_root}>
                        <div id="target" className={classes.target} />
                        <canvas id="game_canvas" className={classes.game_canvas} />
                        <GameTarget Size={TargetSize} className={Classes.target} />
                    {ShowWarning && <Fade in={ShowWarning} timeout={{enter: 100, exit: 2000}}>
                        */
                    //{(true || ShowPreFlight) && <Fade in={ShowPreFlight} timeout={{enter: 1000, exit: 5000}}></Fade>
                                //Display={ShowPreFlight}  />
                    //<canvas id="drill_output" className={(props.GameStarted === true) ? classes.game_canvas : classes.no_game_canvas} />

    return (
        <React.Fragment>

            { ShowTutorial && <Tutorial  Show={Show} Dismiss={handleDismissTutorial}/> }
            <Fade in={State.authed} timeout={{enter: 2000, exit: 2000}}>
                <React.Fragment>
                    {false && ShowSteps && <Notice Instrns={Instrns} BarColor={"yellow"} FontColor={"red"} Display={ShowSteps} />}
                    {ShowPreFlight && <Fade in={ShowPreFlight} timeout={{enter: 1000, exit: 5000}}>
                        <Notice Instrns={WarningText} 
                                BarColor={"#c3ab19"} 
                                FontColor={"white"} 
                                Style={{position: "absolute", top: "50px", left: "0px"}} 
                                Display={ShowPreFlight} />
                    </Fade>}

                    {ShowWarning && <Fade in={ShowWarning} timeout={{enter: 100, exit: 2000}}>
                        <Notice Instrns={WarningText} 
                                BarColor={"red"} 
                                FontColor={"white"} 
                                Style={{position: "absolute", top: "50px", left: "0px"}}
                                Display={ShowWarning}  />
                    </Fade>}

                        <Container id="drill_video_container" style={{width: Width}}
                            className={(props.Replay === true) ? classes.replay_game_root : classes.game_root}>

                            {!props.GameStarted &&  <Direction Directions={props.UseDirections} />}

                            <Container className={classes.stars_container}>
                                <Stars StarCnt={StarCnt}/>
                            </Container>

                            <GameTarget Size={TargetSize} />
                            <canvas id="drill_output" className={classes.game_canvas} />
                            <canvas id="output" className={classes.game_output} />
                        </Container>

                </React.Fragment>
            </Fade>

            {renderRedirect()}
        </React.Fragment>
    )
}

export default withRouter(Game)
